import React, { useEffect, useState } from "react";
import { ActionPopup, HtmlAlert, HtmlButton } from "../../../components/ui/Html";
import { fieldContainsValue } from "../../../controllers/common";
import ShowContentModal from "../../../components/ui/Modals";
import { Input, PasswordInput } from "../../../components/ui/form/Inputs";
import { takeReadAbelError } from "../../../controllers/readAbleError";
import { changePasswordAPI } from "../../../api/account";
import Cookies from "js-cookie";
import { tokenManager } from "services/client/token-manager";

export default function PasswordChange({
  onClick = () => {},
  button = true,
  open,
  onClose = () => {},
}) {
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({});
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [fieldsError, setFieldsError] = useState({});
  const [loader, setLoader] = useState(false);
  const clearAlert = () => {
    setAlert({ type: "", message: "" });
  };
  useEffect(() => {
    setShowModal(open);
  }, [open]);

  function isStrongPassword(password) {
    // Minimum 8 characters, at least one uppercase, one lowercase, one number, and one special character
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return strongPasswordRegex.test(password);
  }
  const handleChangePassrod = async (data) => {
    setLoader(true);
    try {
      if (!fieldContainsValue(data?.old_password)) {
        throw "Old password is required.";
      }
      if (!fieldContainsValue(data?.new_password)) {
        throw "New password is required.";
      }
      if (!fieldContainsValue(data?.confirm_password)) {
        throw "Confirm password is required.";
      }
      if (data?.new_password !== data?.confirm_password) {
        throw "New password and confirm password do not match.";
      }
      if (!isStrongPassword(data?.new_password)) {
        throw "Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character.";
      }
      // check strong password validation here
      const payload = {
        old_password: data?.old_password,
        new_password: data?.new_password,
      };

      // const response = await changePasswordAPI(payload)

      const result = await changePasswordAPI(payload);
      if (result?.statusCode === 200) {
        setAlert({ type: "success", message: "Password changed successfully" });
        setTimeout(() => {
          handleLogout();
        }, 100);
      } else {
        throw "Unable to update your password please try again later.";
      }
    } catch (error) {
      // throw error
      const message = takeReadAbelError(error);
      setAlert({ type: "error", message: message });
    } finally {
      setLoader(false);
    }
  };
  const handleLogout = () => {
    tokenManager.clearAll();
    Cookies.remove("accountDetails");
    // Cookies.remove("cookiesSearchBarKey"); // clear the searchBarKey on logout
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("roles");
    localStorage.removeItem("searchBarKeyStorage"); // clear all persisted searchBarKeys
    // navigate("/login");
    window.location.href = "/login";
  };
  const onChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    clearAlert();

    if (name === "new_password") {
      setFieldsError({ ...fieldsError, [name]: "Your password strength is weak." });
      if (!isStrongPassword(value)) {
      } else if (fieldContainsValue(data["old_password"]) && data["old_password"] === value) {
        setFieldsError({ ...fieldsError, [name]: "Old password and new password cannot be same." });
      } else {
        setFieldsError({ ...fieldsError, [name]: null });
      }
    }
    if (name === "confirm_password" && fieldContainsValue(data?.new_password)) {
      if (data?.new_password !== value) {
        setFieldsError({ ...fieldsError, [name]: "Confirm password must match the password." });
      } else {
        setFieldsError({ ...fieldsError, [name]: null });
      }
    }

    setData({ ...data, [name]: value });
  };
  const onModalClose = () => {
    setShowModal(false);
    clearAlert();
    setFieldsError({});
    setData({});
  };
  return (
    <>
      <ShowContentModal
        open={showModal}
        mask={true}
        width="400px"
        title="Change Password"
        close={onModalClose}
        element={
          <div className="flex flex-col gap-1">
            {alert?.message !== "" && (
              <HtmlAlert
                message={alert?.message}
                type={alert?.type}
                showIcon={true}
                onClose={clearAlert}
              />
            )}
            <PasswordInput
              error={fieldsError?.old_password}
              onChange={onChange}
              title="Old Password"
              name="old_password"
              type="password"
              placeholder="Old Password"
            />
            <PasswordInput
              error={fieldsError?.new_password}
              onChange={onChange}
              title="New Password"
              name="new_password"
              type="password"
              placeholder="New Password"
            />
            <PasswordInput
              error={fieldsError?.confirm_password}
              onChange={onChange}
              title="Confirm Password"
              name="confirm_password"
              type="password"
              placeholder="Confirm Password"
            />

            {/* <HtmlButton text="Update" onClick={handleChangePassrod} /> */}
            <div className="flex justify-end items-center gap-4">
              <HtmlButton onClick={onModalClose} type="discard" text="Cancel" />
              <HtmlButton
                loading={loader}
                onClick={() => {
                  handleChangePassrod(data);
                }}
                type="save"
                text="Update"
              />
            </div>
          </div>
        }
      />
      {button && (
        <div
          className="px-4 py-2 text-gray-800 hover:bg-gray-100 cursor-pointer"
          onClick={() => {
            setShowModal(true);
            onClick?.();
          }}
        >
          Change Password
        </div>
      )}
    </>
  );
}
